import React, {useState} from 'react'
import {Steps} from 'antd'
import StoresListItem from 'modules/ProductDetailPage/StoresListItem'
import WarningDeliveryAddress from 'components/WarningDeliveryAddress'

const DetailSteps = ({data, t}) => {
  const [currentStep, setCurrentStep] = useState(0)

  return (
    <div className='productDetail-details'>
      <div className='productDetail-detailsSteps'>
        <div>
          <Steps type='navigation' onChange={i => setCurrentStep(i)} current={currentStep}>
            <Steps.Step title={t('STORES')}/>
            <Steps.Step title={t('PRODUCT DESCRIPTION')}/>
            <Steps.Step title={t('TECHNICAL SPECIFICATION')}/>
          </Steps>
        </div>
      </div>

      <div className='productDetail-detailsSlides'>
        <div className={`productDetail-detailsSlideActive${currentStep}`}>
          <div>
            <div className='productDetail-stores'>
              <WarningDeliveryAddress/>

              <h6><b>{t('Buildiro recommend')}</b></h6>
              <ul className='productDetail-storesList'>
                <StoresListItem store={data.merchant} t={t}/>
              </ul>
              <h6><b>{t('Available in 7 shops')}</b> {t('in your area')}</h6>
              <ul className='productDetail-storesList'>
                <StoresListItem store={data.merchant} t={t}/>
                <StoresListItem store={data.merchant} t={t}/>
                <StoresListItem store={data.merchant} t={t}/>
                <StoresListItem store={data.merchant} t={t}/>
                <StoresListItem store={data.merchant} t={t}/>
                <StoresListItem store={data.merchant} t={t}/>
                <StoresListItem store={data.merchant} t={t}/>
              </ul>
              <h6><b>{t('Other stores')}</b> {t('do not deliver to your address')}</h6>
              <ul className='productDetail-storesList productDetail-storesListDisabled'>
                <StoresListItem store={data.merchant} t={t}/>
                <StoresListItem store={data.merchant} t={t}/>
              </ul>
            </div>
          </div>
          <div>
            <div className='productDetail-description'>
              Description placeholder
            </div>
          </div>
          <div>
            <div className='productDetail-specs'>
              Specs placeholder
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DetailSteps
